module.exports = __webpack_public_path__ + "static/media/language_icon.c741c2a6.svg";